import React, { RefObject } from 'react'
import { ReactComponent as Quotes } from '../../../assets/icons/quotes.svg'

interface TestimonialTextProps {
  quote: string
  name: string
  position: string
  company: string
  titleRef?: RefObject<HTMLDivElement>
}

const TestimonialText = ({ quote, name, position, company, titleRef }: TestimonialTextProps) => {
    return (
        <div>
            <div className='flex flex-col justify-center md:items-start items-center text-center md:text-left'>
                <div className='p-4 rounded-full bg-sand w-max'>
                    <Quotes className='w-5 h-5' />
                </div>
                <p className='opacity-100 py-8 text-base md:text-xl max-w-[410px]' ref={titleRef}>
                    {quote}
                </p>
                {name && <h6 className='testimonial-name'>{name}</h6>}
                {position && <h6 className='testimonial-name'>{position}</h6>}
                {company && <h6 className='testimonial-name'>{company}</h6>}
            </div>
        </div>
    )
}

export default TestimonialText
